import { ColumnHelper } from "@tanstack/react-table";
import { Typography } from "PFComponents/typography";
import { Activity, EconomicsVacancy } from "PFTypes";
import { useCallback } from "react";

import { useCostFieldLabel } from "../../../use_cost_field_label";
import css from "../vacancies_table.module.scss";

export const useCostFieldColumn = (activity: Activity) => {
  const costFieldLabel = useCostFieldLabel(activity);

  return useCallback(
    (columnHelper: ColumnHelper<EconomicsVacancy>) =>
      columnHelper.accessor(({ costFieldValue }) => costFieldValue, {
        id: "costFieldValue",
        header: () => (
          <Typography className={css.costFieldHeader} variant="bodyRegular" textOverflow="clip">
            {costFieldLabel}
          </Typography>
        ),
        cell: (info) => (
          <Typography className={css.gradeCellContent} variant="bodyRegular" textOverflow="clip">
            {info.getValue() || "-"}
          </Typography>
        ),
        size: 100,
        enableSorting: true
      }),
    [costFieldLabel]
  );
};
